import { Container } from "react-bootstrap";

export const Blogs = () => {
  return (
    <section className="blogs" id="blogs">
      <Container>
        <div className="blogs-inner">
          <span className="blogs-label">My Writing</span>
          <h2 className="blogs-h2">Blogs</h2>
          <p className="blogs-desc">
            I write about HCI, software engineering, automation, and everything in between.
          </p>
          <a
            href="https://medium.com/@fariahricha1301"
            target="_blank"
            rel="noreferrer"
            className="blogs-btn"
          >
            Read my blogs here →
          </a>
        </div>
      </Container>
    </section>
  );
};
